import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";
import Swiper, {Autoplay, EffectFade, Navigation, Pagination} from "swiper";
// import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data() {
        return {
            deviceWidth: {
                type: Number,
                default: 0
            }
        };
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
        this.deviceWidth = window.innerWidth;
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function() {
            self.$nextTick(function() {
                // banner initialize
                // banner
                const banner_swiper = new Swiper(".banner_swiper", {
                    // configure Swiper to use modules
                    modules: [Navigation, Autoplay, EffectFade],
                    // Optional parameters
                    loop: true,
                    effect: 'fade',
                    //autoplay:true,
                    // Navigation arrows
                    navigation: {
                        nextEl: ".banner-button-next",
                        prevEl: ".banner-button-prev",
                    },
                    on: {
                        slideChange:function(swiper){
                            $('.banner_swiper .scroll-txt h3').hide();
                            $('.banner_swiper .scroll-txt h3').eq(swiper.realIndex).show()
                        }
                    }
                });

                // 聚焦點
                const recent_update_swiper = new Swiper(".recent_update_swiper", {
                    // configure Swiper to use modules
                    modules: [Navigation, Autoplay, Pagination, EffectFade],
                    // Optional parameters
                    loop: true,
                    effect: 'fade',
                    autoplay:true,
                    // Navigation arrows
                    navigation: {
                        nextEl: ".recent_update-button-next",
                        prevEl: ".recent_update-button-prev",
                    },
                    // If we need pagination
                    pagination: {
                        el: '.recent_update-pagination',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        },
                    },
                    slidesPerView: 1,
                    spaceBetween: 0,
                });

                //$( window ).resize(function() {
                //    self.deviceWidth = window.innerWidth;
                //});
            });
        });
        
    },
    methods: {  
        checkURL(urlString) {
            let resultString = urlString;
            if(resultString.indexOf("http") == -1 && resultString.indexOf("https") == -1){
                resultString = "http://" + resultString;
            }
            return resultString;
        }
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        recentNewsData() {
            return _.get(this, 'contentData.newsList', []) || [];
        },
        bannersData() {
            return _.get(this, 'contentData.bannerList', []) || [];
        },
    }, // end of computed
}).$mount('#app');